module.exports = "#containerHr{\r\n\tdisplay: none;\r\n}\r\n\r\n@media only screen and (max-width: 600px){\r\n\t#newPasswordAgainContainer{\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t#newPasswordContainer{\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t#containerHr{\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/password-dialog/password-dialog.component.css
// module id = ./src/app/shared/components/password-dialog/password-dialog.component.css
// module chunks = main